// @flow

export const RESPONSE = 'RESPONSE';
export const SIGNAL = 'SIGNAL';
export const START_SESSION = 'START_SESSION';
export const JOIN_SESSION = 'JOIN_SESSION';
export const LEAVE_SESSION = 'LEAVE_SESSION';
export const SESSION_QUEUE = 'SESSION_QUEUE';
export const INVITE_TO_SESSION = 'INVITE_TO_SESSION';
export const CANCEL_INVITE_TO_SESSION = 'CANCEL_INVITE_TO_SESSION';
export const DECLINE_INVITE_TO_SESSION = 'DECLINE_INVITE_TO_SESSION';
export const ABORT_SESSION_JOIN_REQUEST = 'ABORT_SESSION_JOIN_REQUEST';
export const SESSION_JOIN_REQUEST = 'SESSION_JOIN_REQUEST';
export const SESSION_JOIN_RESPONSE = 'SESSION_JOIN_RESPONSE';
export const REMOVE_FROM_SESSION = 'REMOVE_FROM_SESSION';
export const AUTOMATIC_DISCOVERY_ROOM_ID = 'c44f83c3-78ca-4f29-a134-33f6a5705eec';
